import { createSelector } from '@ngrx/store';
import {
  IOrderSummary,
  IOrderTicket,
  ITicketDescriptionFields,
  ITicketProductWithBundleType,
  LoadingDetails,
  LoadState,
} from '@nx-ng/types';
import {
  selectAllFares,
  selectFareIdsAndDescriptions,
} from '@modules/ticket-fares-store';
import { Order } from '../client/src';
import { getOrderFeatureState, IOrderFeatureState } from '../reducers';
import { IOrderState } from '../reducers/order-store.reducer';
import {
  fetchTicketIdsFromOrder,
  mapOrderToOrderSummary,
  mapOrderToOrderTicketList,
} from '../util';
import { getLoadingDetails } from '@nx-ng/util/get-loading-details';

export const selectOrderState = createSelector(
  getOrderFeatureState,
  (state: IOrderFeatureState) => state?.order
);

export const selectOrderResponse = createSelector(
  selectOrderState,
  (state: IOrderState | undefined) => state?.order
);

export const selectOrderLoadState = createSelector(
  selectOrderState,
  (state: IOrderState) => state?.loaded
);

export const selectOrderSummary = createSelector(
  selectOrderResponse,
  selectAllFares,
  (
    order?: Order,
    fareIdsAndDescriptions?: ITicketProductWithBundleType[]
  ): IOrderSummary =>
    mapOrderToOrderSummary({
      order,
      fareIdsAndDescriptions,
    })
);

export const selectOrderTickets = createSelector(
  selectOrderResponse,
  selectFareIdsAndDescriptions,
  (
    order?: Order,
    fareIdsAndDescriptions?: ITicketDescriptionFields
  ): IOrderTicket[] => {
    return mapOrderToOrderTicketList({
      order,
      fareIdsAndDescriptions,
    });
  }
);

export const selectOrderTicketIds = createSelector(
  selectOrderResponse,
  (order?: Order): string[] => {
    return fetchTicketIdsFromOrder(order);
  }
);

export const selectOrderLoading = createSelector(
  selectOrderState,
  (state: IOrderState | undefined): LoadingDetails => {
    if (state?.loaded) {
      return getLoadingDetails(state?.loaded, 'loading_booking_confirmation');
    }

    return getLoadingDetails(
      LoadState.NOT_LOADED,
      'loading_booking_confirmation'
    );
  }
);
